import React, { useEffect } from 'react'
import Presentation from './Components/Presentation';
import SkillsScreen from './Components/SkillsScreen';
import AboutMe from './Components/AboutMe';
import Proyects from './Components/ProyectsScreen';
import ScrollBar from './Components/ScrollBar';
import { Routes, Route } from 'react-router';
import './App.css';
import Counter from './Proyects/Counter';

function App() {
  
  useEffect(() => {
    document.documentElement.scrollTop = 1
  })
  return (
    <div id="app">
      <Routes>

        <Route exact path='/' 
            element={<>
              <ScrollBar />
              <Presentation />
              <AboutMe />
              <SkillsScreen />
              <Proyects />
            </>}
        />

        {/* <Route exact path="/projects/counter" element={<Counter/>}/> */}

        {/* <Route exact path="/:id" element={<h2>Hola</h2>} /> */}


      </Routes>
    </div>

  );
}

export default App;
